// extracted by mini-css-extract-plugin
export var highlightFade = "_2g-4";
export var highlighted = "_2g-3";
export var table = "_2g-1";
export var tableContainer = "_2g-0";
export var totalsRow = "_2g-2";